import { useEffect } from 'react';
import { useAuth } from '@/components/AuthProvider';
import { usePushNotifications, isPushDisabledByUser } from '@/hooks/usePushNotifications';
import { useAppBadge } from '@/hooks/useAppBadge';

export function PushNotificationManager() {
  const { user } = useAuth();
  const { permission, token, requestPermission, isSupported } = usePushNotifications();

  useAppBadge();

  useEffect(() => {
    if (!user || !isSupported || permission !== 'granted') return;

    if (isPushDisabledByUser(user.id)) return;

    if (!token && sessionStorage.getItem('fcm_auto_register_attempted') !== 'true') {
      sessionStorage.setItem('fcm_auto_register_attempted', 'true');
      requestPermission({ silent: true });
    }
  }, [user, isSupported, permission, token, requestPermission]);

  return null;
}
